import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, tap } from 'rxjs';
import { RequestHandlerParams } from './types/api-service.types';
import { MarketingReferral } from './types/common.types';
import { NotificationService } from './notification/notification.service';

@Injectable({
    providedIn: 'root'
})
export class PromotionsService {

    #apiService = inject(ApiService);
    #notificationService = inject(NotificationService);


    getCouponInfo(promotionInfo: MarketingReferral, showDefaultMessage: boolean = false): Observable<any> {
        const payload: RequestHandlerParams = {
            endpoint: `/promotions`,
            method: 'POST',
            apiV3: true,
            body: promotionInfo,
            showErrorMessage: showDefaultMessage
        };

        return this.#apiService.handleRequest(payload).pipe(
            tap((res: any) => {
                if (res.name && showDefaultMessage)
                    this.#notificationService.show({ text: `Discount successfully applied - ${res.name}`, type: 'success' });
            })
        );
    }
}